<template>
    <div style="width:1400px; margin:0 auto; background:#fff;">
        <div style="width:1300px; margin:0 auto; padding:10px 0; ">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item>{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item>{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class='l12payeveryday_ctrl'>
            <div class="l12payeveryday_searchbar">
                <a-form class="search_form" layout="inline">
                    <a-form-item>
                        <a-radio-group v-model="params.mobile_type">
                            <a-radio-button value="全部">全部</a-radio-button>
                            <a-radio-button value="iphone"><a-icon type="apple" /></a-radio-button>
                            <a-radio-button value="android"><a-icon type="android" /></a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item>
                        <Server pos="left" v-model="params.server"/>
                    </a-form-item>
                    <a-form-item>
                        <a-date-picker placeholder="选择查询日期" v-model="params.begin_date" :allowClear="false"/>
                    </a-form-item>
                    <a-form-item>
                    对比
                    </a-form-item>
                    <a-form-item>
                        <a-date-picker placeholder="选择对比日期" v-model="params.end_date" :allowClear="false"/>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" html-type="submit" @click="getData">查询</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div v-if="data">
                <div class='l12pay-container'>
                    <div class='pay-line'>
                        <div class="ellipse-result black-color font-bold">
                            <div class="ellipse-container-row-2">
                            <span class='text-title'>每日总付费金额</span>
                            <span class='big-number'>{{this.data.pay_total[0]}}</span>
                            <a-icon type="caret-down" v-if="this.data.pay_total[1] < 0" class="triangle-green"/>
                            <a-icon type="caret-up" v-else class="triangle-red"/>
                            <span class='small-number'>{{Math.abs(this.data.pay_total[1]) + '%'}}</span>
                            </div>
                            <div>
                            <span>对比{{current_params.end_date}}:</span>
                            <span>{{this.data.pay_total[2]}}</span>
                            </div>
                        </div>
                    </div>
                    <div class='link-line-dev'>
                        <div style="width: 100%;height: 23px;">
                            <span class="triangle-up"></span>
                        </div>
                        <div>
                            <span class="line-zhexian"></span>
                        </div>
                    </div>
                    <div class="pay-line" id = 'pay-line-2'>
                        <div class="ellipse-result black-color font-bold">
                            <div class="ellipse-container-row-2">
                            <span class='text-title'>每日角色付费率</span>
                            <span class='big-number'>{{this.data.pay_ratio[0]}}</span>
                            <a-icon type="caret-down" v-if="this.data.pay_ratio[1] < 0" class="triangle-green"/>
                            <a-icon type="caret-up" v-else class="triangle-red"/>
                            <span class='small-number'>{{Math.abs(this.data.pay_ratio[1]) + '%'}}</span>
                            </div>
                            <div>
                            <span>对比{{current_params.end_date}}:</span>
                            <span>{{this.data.pay_ratio[2]}}</span>
                            </div>
                        </div>
                        <div class="ellipse-result black-color font-bold">
                            <div class="ellipse-container-row-2">
                            <span class='text-title'>每日登陆角色数</span>
                            <span class='big-number'>{{this.data.login_num[0]}}</span>
                            <a-icon type="caret-down" v-if="this.data.login_num[1] < 0" class="triangle-green"/>
                            <a-icon type="caret-up" v-else class="triangle-red"/>
                            <span class='small-number'>{{Math.abs(this.data.login_num[1]) + '%'}}</span>
                            </div>
                            <div>
                            <span>对比{{current_params.end_date}}:</span>
                            <span>{{this.data.login_num[2]}}</span>
                            </div>
                        </div>
                        <div class="ellipse-result black-color font-bold">
                            <div class="ellipse-container-row-2">
                            <span class='text-title'>每日ARPU值</span>
                            <span class='big-number'>{{this.data.arppu[0]}}</span>
                            <a-icon type="caret-down" v-if="this.data.arppu[1] < 0" class="triangle-green"/>
                            <a-icon type="caret-up" v-else class="triangle-red"/>
                            <span class='small-number'>{{Math.abs(this.data.arppu[1]) + '%'}}</span>
                            </div>
                            <div>
                            <span>对比{{current_params.end_date}}:</span>
                            <span>{{this.data.arppu[2]}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="data">
                <div class="custom_el_tabs">
                    <div class='custom_header_title'>
                        <a-icon type="bar-chart" />
                        <span> 各渠道付费详情</span>  
                    </div>
                    <div class="button_container">
                        <button class="select-button" @click="selectDg=false" :class="{activeSelectButton: !selectDg}">图</button>
                        <button class="select-button" @click="selectDg=true" :class="{activeSelectButton: selectDg}">表</button>
                    </div>
                    <a-tabs v-model="activeType" type="card">
                        <a-tab-pane tab="总金额" key="totalmoney">
                            <div v-if="data.total_money_detail.length > 0" v-for="(d, i) in data.total_money_detail.slice(0, 3)" class="ellipse-result-long">
                            <div>
                                <span class='font-size11'>波动TOP{{i+1}}：{{d.company}}</span>
                                <span class='font-size15 green-font font-bold'>{{d.nowmonth}}</span>
                            </div>
                            <div>
                                <span class='font-size08 silver-font bg-gray'>对比{{end_date}}：</span>
                                <span class="font-size08 font-bold">{{d.premonth}}</span>
                                <a-icon type="caret-down" v-if="d.ratio < 0" class="triangle-green"/>
                                <a-icon type="caret-up" v-else class="triangle-red"/>
                                <span class="font-size08 font-bold green-font">{{Math.abs(d.ratio) + '%'}}</span>
                            </div>
                            </div>
                            <Chart v-if="!selectDg" :conf="chart_conf" :datas="data.total_money_detail" :fields="[]" style="margin:30px 0;"/>
                            <DataTable v-show="selectDg" :fields="table_fields" :datas="data.total_money_detail" style="margin:30px 0;"/>
                        </a-tab-pane>
                        <a-tab-pane tab="角色付费率" key="payratio">
                            <div v-if="data.pay_ratio_detail.length > 0" v-for="(d, i) in data.pay_ratio_detail.slice(0, 3)" class="ellipse-result-long">
                            <div>
                                <span class='font-size11'>波动TOP{{i+1}}：{{d.company}}</span>
                                <span class='font-size15 green-font font-bold'>{{d.nowmonth + '%'}}</span>
                            </div>
                            <div>
                                <span class='font-size08 silver-font bg-gray'>对比{{end_date}}</span>
                                <span class="font-size08 font-bold">{{d.premonth}}</span>
                                <a-icon type="caret-down" v-if="d.ratio < 0" class="triangle-green"/>
                                <a-icon type="caret-up" v-else class="triangle-red"/>
                                <span class="font-size08 font-bold green-font">{{Math.abs(d.ratio) + '%'}}</span>
                            </div>
                            </div>
                            <Chart v-if="!selectDg" :conf="chart_conf" :datas="data.pay_ratio_detail" :fields="[]" style="margin:30px 0;"/>
                            <DataTable v-show="selectDg" :fields="table_fields" :datas="data.pay_ratio_detail" style="margin:30px 0;"/>
                        </a-tab-pane>
                        <a-tab-pane tab="登陆角色数" key="logrolenum">
                            <div v-if="data.login_num_detail.length > 0" v-for="(d, i) in data.login_num_detail.slice(0, 3)" class="ellipse-result-long">
                            <div>
                                <span class='font-size11'>波动TOP{{i+1}}：{{d.company}}</span>
                                <span class='font-size15 green-font font-bold'>{{d.nowmonth}}</span>
                            </div>
                            <div>
                                <span class='font-size08 silver-font bg-gray'>对比{{end_date}}</span>
                                <span class="font-size08 font-bold">{{d.premonth}}</span>
                                <a-icon type="caret-down" v-if="d.ratio < 0" class="triangle-green"/>
                                <a-icon type="caret-up" v-else class="triangle-red"/>
                                <span class="font-size08 font-bold green-font">{{Math.abs(d.ratio) + '%'}}</span>
                            </div>
                            </div>
                            <Chart v-if="!selectDg" :conf="chart_conf" :datas="data.login_num_detail" :fields="[]" style="margin:30px 0;"/>
                            <DataTable v-show="selectDg" :fields="table_fields" :datas="data.login_num_detail" style="margin:30px 0;"/>
                        </a-tab-pane>
                        <a-tab-pane tab="ARPPU" key="ARPPU">
                            <div v-if="data.arppu_detail.length > 0" v-for="(d, i) in data.arppu_detail.slice(0, 3)" class="ellipse-result-long">
                            <div>
                                <span class='font-size11'>波动TOP{{i+1}}：{{d.company}}</span>
                                <span class='font-size15 green-font font-bold'>{{d.nowmonth_f}}</span>
                            </div>
                            <div>
                                <span class='font-size08 silver-font bg-gray'>对比{{end_date}}</span>
                                <span class="font-size08 font-bold">{{d.premonth_f}}</span>
                                <a-icon type="caret-down" v-if="d.ratio < 0" class="triangle-green"/>
                                <a-icon type="caret-up" v-else class="triangle-red"/>
                                <span class="font-size08 font-bold green-font">{{Math.abs(d.ratio) + '%'}}</span>
                            </div>
                            </div>
                            <Chart v-if="!selectDg" :conf="chart_conf" :datas="data.arppu_detail" :fields="[]" style="margin:30px 0;"/>
                            <DataTable v-show="selectDg" :fields="table_fields" :datas="data.arppu_detail" style="margin:30px 0;"/>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Server from '@/components/common/search/server.vue'
import moment from "moment"
import {Form, DatePicker, Input} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(DatePicker)
Vue.use(Input)
Vue.use(Form)
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
export default {
    mixins: [ctrlMixin],
    name:'l12payeveryday',
    props: ['parent', 'name'],
    components: {
        DataTable,
        Chart,
        Server,
    },
    mounted(){
        this.initParams()
        this.getData()
    },
    watch: {
        selectdate(newV) {
            this.getData()
        }
    },
    data() {
        return {
            params: {
                mobile_type: '全部',
                begin_date: null,
                end_date: null,
                server: null,
            },
            current_params: {
                end_date: null,
            },
            data: null,
            activeType: 'totalmoney',
            selectDg: false,
            chart: {
                type:'mixin',
                x:{id:'company', title:'渠道'},
                y: [
                    {id:'nowmonth', title:'本期', pos:'l'},
                    {id:'premonth', title:'上期', pos:'l'},
                ],
                yaxis: {
                    left: {title:'付费总金额', type:'bar', series_type:'team'}
                },
                color: ['#52e4cb','#ffbc75']
            },
            fields: [
                {id: 'company', title:'渠道'},
                {id: 'nowmonth', title:'本期'},
                {id: 'premonth', title:'上期'},
            ],
        }
    },
    computed: {
        chart_conf() {
            let conf = Object.assign({}, this.chart)
            conf.y[0].title = this.current_params.begin_date
            conf.y[1].title = this.current_params.end_date
            const tabNames = {
                'totalmoney':'付费总金额',
                'payratio':'付费率',
                'logrolenum':'登陆角色数',
                'ARPPU':'ARPPU',
            }
            conf.yaxis.left.title = tabNames[this.activeType]
            return conf
        },
        table_fields() {
            let fields = [
                {id: 'company', title:'渠道', width:'40%'},
                {id: 'nowmonth', title:'本期', width:'30%'},
                {id: 'premonth', title:'上期', width:'30%'},
            ]
            fields[1].title = this.current_params.begin_date
            fields[2].title = this.current_params.end_date
            return fields
        },
    },
    methods: {
        initParams() {
            this.params.begin_date = moment().subtract(1,'day')
            this.params.end_date = moment().subtract(2,'day')
        },
        getData() {
            this.loading = true
            let params = Object.assign({}, this.params)
            params.begin_date = params.begin_date.format('YYYY-MM-DD')
            params.end_date = params.end_date.format('YYYY-MM-DD')
            this.current_params = params
            this.$service.query(this.queryId, params).then((data)=>{
                this.data = data
                this.loading = false
            }).catch((data)=> {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="less" scoped>
@width:1300px;

.l12payeveryday_ctrl {
    width:@width;
    margin:0 auto;
    overflow: hidden;
    .l12payeveryday_searchbar {
        margin:0 0 20px 0;
    }

    .button_container{
        position: absolute;
        right: 0px;
        z-index: 1000;
        }
        .select-button {
        width: 30px;
        height: 30px;
        border: 2px solid #d6d6d6;
        border-radius: 50%;
        cursor: pointer;
        background-color: #fff;
        font-size: 16px;
        outline: none;
        }
        .activeSelectButton {
        background-color: #41cac0;
        border-color: #41cac0;
        color: #fff;
        }
        .custom_el_tabs {
            position: relative;
        }
        .custom_header_title {
        font-size: 22px;
        vertical-align: middle;
        font-weight: 700;
        color: #2CBFBE;
        padding-top: 2px;
        width: 201px;
        border-bottom: 4px solid;
        margin: 20px 0;
        }
        .custom-ratio-group {
        margin-bottom: 10px;
        margin-right: 13px;
        }
        .custom_ratio img {
        width: 25px;
        height: 24px;
        }
        .silver-font {
        color: #8492A6;
        }
        .green-font {
        color: #3C8785;
        }
        .triangle-red {
        color: #FF6200;
        }
        .triangle-green {
        color: #04C7A0
        }
        .black-color {
        color: #3D4256;
        }
        .white-color {
        color: white;
        }
        .font-bold {
        font-weight: 700;
        }
        .green-gradient {
        background-color: #35CCCB !important;
        /*background: radial-gradient(ellipse farthest-corner at -10px -5px, #35CCCB 0%,#35CCCB 50%,#2CBFBE 50%,#2CBFBE 100%) !important;*/
        }
        .font-size08 {
        font-size: 0.8em;
        }
        .font-size11 {
        font-size: 1.1em;
        }
        .font-size15 {
        font-size: 1.5em;
        }
        .link-line-dev{
        width:100%;
        line-height: 0;
        }
        .line-zhexian {
        display: inline-block;
        width: 733px;
        height: 30px;
        border-top: 2px #00AFA4 solid;
        }
        .line-zhexian:before {
            border-top: 2px #00AFA4 solid;
            content: '';
            display: inline-block;
            width: 30px;
            height: 20px;
            -ms-transform: rotate(-45deg);
            transform: rotate(-45deg);
            left: -355px;
            top: 6px;
            position: relative;
        }
        .line-zhexian:after {
            border-top: 2px #00AFA4 solid;
            content: '';
            display: inline-block;
            width: 30px;
            height: 20px;
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
            left: 355px;
            top: 6px;
            position: relative;
        }
        .pay-line {
        width: 100%;
        height: 6em;
        }
        .l12pay-container {
        margin: 0 auto;
        width: 100%;
        text-align: center;
        }
        .triganle-down {
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: 2px;
        border-top: 4px solid;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
        }
        .link-line-span {
        border-width: 1px;
        display: inline-block;
        }
        .triangle-up {
        width:0;
        height:0;
        border-width:0 9px 17px;
        border-style:solid;
        border-color:transparent transparent #00AFA4;
        }

        .triangle-left:after {
        position: absolute;
        border-color: transparent transparent #00AFA4;
        }
        .ellipse-container {
        display: inline-block;
        line-height: 78px;
        }
        .ellipse-container-row-2 {
        padding-top: 5px;;
        }
        .ellipse-result {
        display: inline-block;
        border-radius: 3em;
        width: 348px;
        height: 86px;
        vertical-align: middle;
        text-align: center;
        margin-left: 2em;
        margin-right: 2em;
        background-color: #E7EFEF;
        /*background: radial-gradient(ellipse farthest-corner at -10px -5px, #E7EFEF 0%,#E7EFEF 50%,#DFE9E9 50%,#DFE9E9 100%);*/
        }
        .ellipse-result-long {
        display: inline-block;
        background-color:#E9F7F5; 
        border-radius: 3em;
        width: 350px;
        height: 4em;
        margin-left: 2em;
        margin-right: 2em;
        padding-left: 13px;
        padding-top: 6px;
        line-height: 1.2;
        }
        .text-title {
        display: inline-block;
        top: -4px;
        position: relative;
        }
        .big-number {
        font-size: 2.5em;
        }
        .small-number {
        font-weight: 700;
        }
}
</style>